module.exports = __webpack_public_path__ + "5d11c22d4684ffd165a1467e1e6250e5.svg";